// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__6ruj+","note":"styles_note__ySWdf"};